/*
  Converts support ticket workflow fields or wizard fields to SwoopForm field definitions.

  Params:
    * fieldsIn  - Array of field definitions from either ticket.workflow_fields.fields or
                  ticket.wizard_fields[wizard step].fields[0].fields
    * data      - JSON data from ticket.ticket_data
    * isWorkflowFields  - True if fields are from workflow_fields (instead of wizard_fields).

*/

import _last from 'lodash/last'

export const convertTicketFields = (fieldsIn, data, isWorkflowFields) => {
  try {
    let fieldsOut = []
    let typeMapping = {
      text: 'text',
      select: 'list',
      textArea: 'textarea',
      team: '',
      date: 'date',
      price: 'number'
    }

    const getId = name => {
      // Gets the SwoopForm field id, which is the name of the data point that will provide the field's data.
      if (!isWorkflowFields) {
        return name
      }
      // Workflow fields need some conversions...

      // Remove the data. property from keys
      name = _last(name.split('data.'))

      // Map the "creator" workflow field to an actual value (not the creator object itself)
      if (name === 'creator') {
        return 'creator.username'
      }

      if (name === 'TicketLocation') {
        return 'ticket_parent.name'
      }

      // If the named value is found inside the ticket_data object, use that...
      if (data && data[name] !== undefined) {
        return `ticket_data.${name}`
      }

      // For non-ticket_data fields we convert field names to snake case so that they map to GQL ticket data
      return name
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase()
    }

    const getType = fieldIn => {
      if (fieldIn.validationRule === 'readonly') {
        return 'text'
      }
      return typeMapping[fieldIn.type] || 'text'
    }

    const getOptions = options => {
      try {
        return options.map(option => {
          return {
            label: option.text,
            value: option.value
          }
        })
      } catch (e) {
        return null
      }
    }

    fieldsIn.forEach(fieldIn => {
      if (fieldIn.type === 'fixedText') {
        fieldsOut.push({
          infotext: fieldIn.description,
          page: fieldIn._page || undefined
        })
      } else {
        fieldsOut.push({
          id: getId(fieldIn.name),
          type: getType(fieldIn),
          label: fieldIn.label || '',
          required: fieldIn.validationRule === 'required',
          disabled: fieldIn.validationRule === 'readonly',
          options: getOptions(fieldIn.options),
          colspan: fieldIn.columns,
          page: fieldIn._page || undefined,
          prefix: fieldIn.type === 'price' ? '$' : fieldIn.textPrepend,
          suffix: fieldIn.textAppend,
          hint: fieldIn.description
        })
      }
    })
    return fieldsOut
  } catch (e) {
    console.log(`COULD NOT CONVERT WORKFLOW FIELDS - ${e}`) // eslint-disable-line no-console
    return []
  }
}
